import React, { useRef } from 'react';
import clsx from "clsx";
import customStyles from "../../../../assets/styles/customStyles";
import { Modal, Row, Col, Image } from "antd";
import CloseIcon from "../../../../assets/images/icon_menus/Close Button.svg";


const CheckList = React.forwardRef((props, ref) => {
    const { handleClose, open, list } = props;
    const pdfExportComponent = useRef(null);

    const classes = customStyles();
    return (
        <Modal title="" open={open} footer={null}
            onCancel={() => handleClose(!open)}
            width={1100}
            closable={false}
            className={clsx(classes.invoiceDesign, classes.removeUnderline)}>
            <Row gutter={75} className={classes.invoiceHeader}>
                <Col span={24} className={clsx(classes.textAlignRight, classes.fontSize0)}>
                    <Image onClick={() => handleClose(!open)} src={CloseIcon} preview={false} className={classes.cursor} />
                </Col>
            </Row>
            <div ref={pdfExportComponent} className={clsx(classes.divToPrint, classes.divToPrintReport)}>
                <div className={clsx(classes.downloaddetails)} style={{ minHeight: 700 }}>
                    <div className={clsx(classes.thirdSectionReport, classes.thirdSection, classes.blackBorderTop)}>
                        {list}
                    </div>
                </div>
            </div>
        </Modal>
    )
});

export default CheckList;